import Vue from 'vue'

import JfPagePart from "./jf-page-part"
Vue.component('jf-page-part', JfPagePart)

import jfCookieConsent from "./jf-cookie-consent"
Vue.component('cookie-consent', jfCookieConsent)
